import * as React from "react";
import styled from "styled-components";

const socialIcons = [
  {
    id: 1,
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/3aa700d0f039553d15c0c5a0f1dff13b29897419c120001dcf6e0d9e90af8f0c?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    alt: "Social Media Icon 1",
  },
  {
    id: 2,
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/0528bf9c2e932adbacd4d99ac1b9380ca7a541f67ff89478dd129880ad36e2ed?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e",
    alt: "Social Media Icon 2",
  },
];

export function SocialIcons() {
  return (
    <IconContainer>
      {socialIcons.map((icon) => (
        <SocialIcon
          key={icon.id}
          loading="lazy"
          src={icon.src}
          alt={icon.alt}
          tabIndex="0"
          role="button"
          onClick={(e) => {
            // if (e.key === "Enter") {
            // Social media link action here
            if (icon.id === 1) window.location.href = "tel:+1234567890";
            else if (icon.id === 2)
              window.location.href = "mailto:mab@bbglobalsolutions.com";
          }}
        />
      ))}
    </IconContainer>
  );
}

const IconContainer = styled.div`
  align-self: stretch;
  display: flex;
  align-items: start;
  gap: 14px;
  justify-content: end;
  margin: auto 0;
  
  @media (max-width: 768px) {
    justify-content: flex-end;
    padding-right: 5px;
    gap: 16px;
  }
`;

const SocialIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 60px;
  cursor: pointer;
  transition: all 0.3s ease;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  
  &:hover {
    transform: translateY(-3px) scale(1.05);
    filter: drop-shadow(0 5px 8px rgba(0, 0, 0, 0.15)) brightness(1.1);
  }
  
  &:active {
    transform: translateY(0) scale(0.98);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
    border-radius: 50%;
  }
  
  @media (max-width: 500px) {
    width: 45px;
    padding: 3px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
`;
